<ng-container>
  <div class="d-flex flex-row align-items-center gap-1 justify-content-center">
    <rx-icon-legacy *ngIf="icon" [icon]="icon"/>
    <span class="title" *ngIf="title">{{title}}</span>
  </div>
</ng-container>
